var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "游戏", clearable: "" },
                  model: {
                    value: _vm.paramsData.appid,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "appid", $$v)
                    },
                    expression: "paramsData.appid"
                  }
                },
                _vm._l(_vm.gameList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.show_name, value: item.appid }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "展示名称" },
                model: {
                  value: _vm.paramsData.show_name,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "show_name", $$v)
                  },
                  expression: "paramsData.show_name"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "服务器", clearable: "" },
                  model: {
                    value: _vm.paramsData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "server_id", $$v)
                    },
                    expression: "paramsData.server_id"
                  }
                },
                _vm._l(_vm.GamesServersList, function(item, index) {
                  return _c(
                    "el-option",
                    {
                      key: index,
                      attrs: { label: item.show_name, value: item.id }
                    },
                    [
                      _vm._v(
                        _vm._s(item.game_show_name + " - " + item.show_name)
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.$refs.addpack.init()
                }
              }
            },
            [_vm._v("新增")]
          ),
          _vm.delIds.length
            ? _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.del(_vm.delIds)
                    }
                  }
                },
                [_vm._v("删除")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("uploadImagetow", {
                ref: "uploadImagetow",
                attrs: {
                  filesname: "product_file",
                  Url: "api/paymentProducts/productMassUpload",
                  title: "批量上传"
                },
                on: {
                  change: function($event) {
                    return _vm.getList(1)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "topBannerTable",
          attrs: { data: _vm.pagingList, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60", type: "selection" }
          }),
          _c("el-table-column", {
            attrs: { prop: "game_show_name", label: "游戏" }
          }),
          _c("el-table-column", {
            attrs: { prop: "server_show_name", label: "服务器" }
          }),
          _c("el-table-column", {
            attrs: { prop: "show_name", label: "展示名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "cp_product", label: "研发商品" }
          }),
          _c("el-table-column", {
            attrs: { prop: "currency", label: "货币类型" }
          }),
          _c("el-table-column", {
            attrs: { prop: "price", label: "价格(分)" }
          }),
          _c("el-table-column", { attrs: { prop: "discount", label: "折扣" } }),
          _c("el-table-column", {
            attrs: { prop: "welfare", label: "返利比" }
          }),
          _c("el-table-column", {
            attrs: { prop: "language", label: "语言信息" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#409EFF" },
                        on: {
                          click: function($event) {
                            return _vm.openView(row)
                          }
                        }
                      },
                      [_vm._v(" 查看 ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(" " + _vm._s(row.state == 2 ? "启用" : "禁用") + " ")
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "操作", width: "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.addpack.init(row)
                          }
                        }
                      },
                      [_vm._v("修改")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.del([row])
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        staticClass: "x-c",
        attrs: {
          layout: "total, prev, pager, next,jumper",
          "current-page": _vm.paramsData.page,
          total: _vm.totalNum,
          "page-size": _vm.paramsData.page_size
        },
        on: { "current-change": _vm.getList }
      }),
      _c("addpack", {
        ref: "addpack",
        attrs: { GamesServersList: _vm.GamesServersList },
        on: { change: _vm.getList }
      }),
      _c("packView", { ref: "packView" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }